import React from 'react';

type HealthStatus = 'healthy' | 'at-risk' | 'critical' | 'recovering' | 'optimized';

interface HealthBadgeProps {
  status: HealthStatus;
  size?: 'sm' | 'md';
}

const config: Record<HealthStatus, { label: string; className: string }> = {
  healthy: { label: 'Healthy', className: 'bg-positive/15 text-positive border border-positive/30' },
  'at-risk': { label: 'At Risk', className: 'bg-warning/15 text-warning border border-warning/30' },
  critical: { label: 'Critical', className: 'bg-negative/15 text-negative border border-negative/30' },
  recovering: { label: 'Recovering', className: 'bg-primary/15 text-primary border border-primary/30' },
  optimized: { label: 'Optimized', className: 'bg-accent/15 text-accent border border-accent/30' },
};

export default function HealthBadge({ status, size = 'md' }: HealthBadgeProps) {
  const { label, className } = config[status];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${
        size === 'sm' ? 'text-2xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      } ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${
        status === 'healthy' ? 'bg-positive' :
        status === 'at-risk' ? 'bg-warning' :
        status === 'critical' ? 'bg-negative' :
        status === 'recovering' ? 'bg-primary' : 'bg-accent'
      }`} />
      {label}
    </span>
  );
}